/* global angular */

angular
.module('gc.embed',[])

.service('EmbedService', [
  '$rootScope', '$window', '$http', '$sce', '$q', '$timeout', 'Utils', 'API_URL',
  function($rootScope, $window, $http, $sce, $q, $timeout, Utils, API_URL) {
  'use strict';

  // Videos
  var REGEX_YOUTUBE       = /(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/ytscreeningroom\?v=|\/feeds\/api\/videos\/|\/user\S*[^\w\-\s]|\S*[^\w\-\s]))([\w\-]{11})[?=&+%\w-]*/i;
  var REGEX_DAILYMOTION   = /dailymotion.com\/video\/([a-zA-Z0-9-_]+)/i;
  var REGEX_TWITCH        = /twitch.tv\/[a-zA_Z0-9_]+/i;
  var REGEX_VIMEO         = /vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)*/i;

  // Images
  var REGEX_FLICKR        = /flickr\.com\/photos\/.+/i;
  var REGEX_INSTAGRAM     = /instagr\.?am(\.com)?\/.+/i;
  var REGEX_ANY_IMAGE     = /(https?:\/\/\S*\.(?:gif|jpg|jpeg|tiff|png|svg|webp)(\?([\w=&_%\-]*))?)/i;

  // Sound
  var REGEX_SPOTIFY       = /open\.spotify\.com\/(track|album|user)\/[a-zA-Z0-9-_]+/i;

  // Othes
  var REGEX_TWITTER       = /twitter\.com?\/.+\/status\/.+/i;

  var that = this;
  var injectedScripts = [];
  var embedCache = {};

  // Extracts all links such as <a href="..."> from HTML, or any url that's not inside a link
  function getLinks(html) {
    var links = [];
    var regexp = /(?:<a [^>]*href=["'](http[^"']+)["'][^>]*>)|(https?:\/\/[^"<\s]+[^.<\s"()][-A-Za-z0-9+&@#\/%=~_|])(?![^<>]*>|[^"]*?<\/a)/g;
    var match = html.match(regexp);

    if (match) {
      match.forEach(function(tag) {
        // Reset regexp
        regexp.lastIndex = 0;

        var results = regexp.exec(tag);
        var url = results[1] || results[2];

        // The editor sometime adds an extra space after an url...
        if (url.slice(-5) === '&nbsp') {
          url = url.substr(0, url.length - 5);
        }

        links.push(url);
      });
    }

    return links;
  }

  // Takes a string containing HTML, detects urls and find the ones that could be embeded.
  this.findEmbedables = function (scope, html) {
    var links = getLinks(html);
    var embedables = [];

    for (var i = 0; i < links.length ; i++) {
      var link = links[i];
      var callback;

      if (link.match(REGEX_YOUTUBE)) {
        callback = fetchYoutube(RegExp.$1, link);
      } else if (link.match(REGEX_DAILYMOTION)) {
        callback = fetchOembed(link, 'https://www.dailymotion.com/services/oembed?autoplay=true&url=http://www.dailymotion.com/video/' + RegExp.$1);
      } else if (link.match(REGEX_TWITCH)) {
        callback = fetchOembed(link, 'https://api.twitch.tv/v5/oembed?autoplay=true&url=' + encodeURIComponent(link));
      } else if (link.match(REGEX_VIMEO)) {
        callback = fetchOembed(link, 'https://vimeo.com/api/oembed.json?autoplay=true&url=' + encodeURIComponent(link));
      } else if (link.match(REGEX_FLICKR)) {
        callback = fetchOembed(link, 'https://www.flickr.com/services/oembed/?format=json&url=' + encodeURIComponent(link), 'jsoncallback');
      } else if (link.match(REGEX_INSTAGRAM)) {
        // Don't load the Instagram widget on small screens
        if ($window.document.body.offsetWidth > 400) {
          callback = fetchOembed(link,
            'https://api.instagram.com/oembed/?maxwidth=320&lang=' + $rootScope.lang + '&omitscript=true&url=' + encodeURIComponent(link)
          );
          loadScript('https://platform.instagram.com/en_US/embeds.js', function() {
            setInterval(function() {
              window.instgrm.Embeds.process();
            }, 1500);
          });
        }
      //} else if (link.match(REGEX_ANY_IMAGE)) {
        //callback = fetchImage(link);
      } else if (link.match(REGEX_SPOTIFY)) {
        callback = fetchOembed(link, 'https://open.spotify.com/oembed?url=' + encodeURIComponent(link));
      } else if (link.match(REGEX_TWITTER)) {
        // Don't load the Twitter widget on small screens
        if ($window.document.body.offsetWidth > 400) {
          callback = fetchOembed(link, (
            'https://publish.twitter.com/oembed' +
              '?lang=' + $rootScope.lang +
              '&omitscript=true' +
              '&theme=' + (CommentService.website.theme || 'light') +
              '&url=' + encodeURIComponent(link)
          ));
          loadScript('https://platform.twitter.com/widgets.js', function() {
            setInterval(function() {
              window.twttr.widgets.load()
            }, 1500);
          });
        }
      } else {
        // None of the above worked, let's try Open Graph
        callback = fetchOpenGraph(link);
      }

      if (callback) {
        embedables.push({
          url: link,
          callback: callback
        });
      }
    }

    return embedables;
  }

  function fetchOembed(initialUrl, oembedUrl, jsonpCallbackParam) {
    return function() {
      // Tell Angular the domain can be trusted
      oembedUrl = $sce.trustAsResourceUrl(oembedUrl);

      // Spotify bug fix:
      // Spotify removes special characters from the callback function name.
      // angular.callbacks._1 becomes angularcallbacks1
      var jsonpCount = angular.callbacks.$$counter.toString(36);
      var jsonpCallbackAlt = 'angularcallbacks' + angular.callbacks.$$counter.toString(36);
      $window[jsonpCallbackAlt] = function(json) {
        angular.callbacks['_' + jsonpCount](json);
      };

      return $http
        .jsonp(oembedUrl, { jsonpCallbackParam: jsonpCallbackParam || 'callback' })
        .then(function(json) {
          if (!json.data || json.data.error) {
            return $q.reject(json.data.error);
          }

          json.data.initialUrl = initialUrl;

          return json.data;
        }, function(err) {
          console.log('embed err', err);
        })

        // Spotify bug fix
        .finally(function() {
          delete($window[jsonpCallbackAlt]);
        });
    }
  }

  function fetchYoutube(videoId, initialUrl) {
    return function() {
      var url = 'https://www.youtube.com/watch?v=' + videoId;

      return $http.post(API_URL + '/pub/scrap', { url }).then(function(json) {
        if (!json.data || json.data.error) {
          return $q.reject(json.data.error);
        }

        var videoDetails = json.data;

        return {
          type: 'video',
          provider_name: 'YouTube',
          provider_url: 'https://www.youtube.com/',
          title: videoDetails.title,
          description: videoDetails.description.replace(/\n|&#10;/g, ' '),
          thumbnail_url: videoDetails.image,
          //thumbnail_height: videoDetails.snippet.thumbnails.medium.height,
          //thumbnail_width: videoDetails.snippet.thumbnails.medium.width,
          //view_count: videoDetails.statistics.viewCount,
          //like_count: videoDetails.statistics.likeCount,
          url: 'https://www.youtube.com/watch?v=' + videoId,
          initialUrl: initialUrl,
          html: '<iframe width=" 459" height="344" src="https://www.youtube.com/embed/' + videoId + '?feature=oembed&autoplay=1" frameborder="0" allowfullscreen="allowfullscreen"></iframe>'
        };
      });
    }
  }

  // Try to load an image and create a proper JSON if the image loads
  function fetchImage(url) {
    url = proxifyImage(url);

    return function() {
      return Utils.preloadImage(url)
        .then(function(imageElement) {
          return {
            type: 'photo',
            width: imageElement.width,
            height: imageElement.height,
            url: url
          }
        });
    }
  }

  // Use a free HTTPS image proxy if the image is not secured
  function proxifyImage(url) {
    if (url && url.indexOf('http://') === 0) {
      return 'https://images.weserv.nl/?url=' + encodeURIComponent(url.substr(7));
    }
    return url;
  }

  // Try to read Open Graph meta tags with the help of YQL by Yahoo
  function fetchOpenGraph(url) {
    return function() {
      return $http.post(API_URL + '/pub/scrap', { url }).then(function(response) {
        var meta = response.data;

        // Success! Let's extract all meta data
        if (meta) {

          // We can't display the embed if the title or the description is missing
          if ((!meta['og:title'] && !meta['title']) || (!meta['og:description'] && !meta['description'])) {
            return $q.reject('Page title/description missing');
          }

          var data = {
            type: 'opengraph',
            provider_url: meta['og:url'] ? meta['og:url'] : url,
            title: meta['og:title'] || meta['title'],
            description: meta['og:description'] || meta['description'],
            initialUrl: url
          };

          if (meta['og:site_name']) {
            data.provider_name = meta['og:site_name'];
          }

          if (meta['og:image:secure_url']) {
            meta['og:image'] = meta['og:image:secure_url'];
          }
          meta['og:image'] = proxifyImage(meta['og:image']);

          if (meta['og:image']) {
            data.image = meta['og:image'];
          }
          else if (meta['image']) {
            data.image = meta['image'];
          }

          return data;
        } else {
          return $q.reject('Page not found');
        }
      }, function(response) {
        // Failure
        return $q.reject(response.status + ' ' + response.statusText);
      });
    };
  }

  // An recursive-asynchronous function that tries to load 1 embedable at a time,
  // until theres no more available embedables or until maxEmbedsNbr is reached.
  this.loadEmbeds = function(scope, embedables, maxEmbedsNbr) {
    if (embedables.length > 0 && maxEmbedsNbr > 0) {

      // The batchId has to be changed each time the embeds are refreshed.
      // Otherwise, some asynchronous embed requests could be displayed on
      // the wrong comment when loading ends.
      var initiatorBatchId = scope.embedBatchId;

      // Take a look into the embed cache, in case that url was already fetched
      if (embedCache[embedables[0].url]) {
        $timeout(function() {
          scope.onEmbedDetected({data: embedCache[embedables[0].url]});
          that.loadEmbeds(scope, embedables.slice(1), maxEmbedsNbr - 1);
        });
        return;
      }

      // Execute the first function
      embedables[0].callback()

        // Success
        .then(function(data) {
          // Save response into the embed cache
          embedCache[embedables[0].url] = data;

          // Display embed
          if (scope.embedBatchId === initiatorBatchId) {
            scope.onEmbedDetected({data: data});
            that.loadEmbeds(scope, embedables.slice(1), maxEmbedsNbr - 1);
          }
        }, function(err) {
          // Failure
          if (scope.embedBatchId === initiatorBatchId) {
            that.loadEmbeds(scope, embedables.slice(1), maxEmbedsNbr);
          }
        });
    }
  }

  // Injects a script from the url
  // If onloadCallback is specified, this function will be called when the script is loaded
  function loadScript(url, onloadCallback) {
    if (injectedScripts.indexOf(url) === -1) {
      var script = $window.document.createElement('script');
      script.async = 'async';
      script.src = url;
      if (onloadCallback) {
        script.onload = onloadCallback;
      }
      $window.document.body.appendChild(script);
    }
  }

}])

.directive('gcEmbed', [
  'CommentService', '$timeout', '$rootScope', 'EmbedService', 'Utils', 'API_URL',
  function(CommentService, $timeout, $rootScope, EmbedService, Utils, API_URL) {
  'use strict';

  function getCommentHTML(element) {
    // if comment.expanded is true
    var expanded = element.querySelector('.full-content');
    return expanded ? expanded.innerHTML : element.innerHTML;
  }

  // fetch an image hosted on graphcomment.com domain
  function fetchGcImage(img) {
    var url = API_URL + '/file/' + img._id + '.' + img.metadata.extension;

    return function() {
      return Utils.preloadImage(url)
        .then(function(imageElement) {
          return {
            hosted: true,
            fileId: img._id,
            type: 'photo',
            width: imageElement.width,
            height: imageElement.height,
            url: url
          }
        });
    }
  }

  function loadEmbeds(scope, html) {
    var embedables = EmbedService.findEmbedables(scope, html);
    EmbedService.loadEmbeds(scope, embedables, CommentService.website.embeded_external_link);
  }

  // Use an IntersectionObserver to only load the embed when it enters the viewport
  function lazyloadEmbeds(scope, element) {
    // Detect if IntersectionObserver API is supported
    if ('IntersectionObserver' in window) {
      var unbind = $rootScope.$on('embeds:load:' + scope.comment._id, function() {
        loadEmbeds(scope, getCommentHTML(element));
        observer.disconnect();
      });

      // Use a margin of 300px, so the embed will start loading 300px before it's inside the viewport
      var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          loadEmbeds(scope, getCommentHTML(element));
          observer.disconnect();
          unbind();
        }
      }, { rootMargin: '0px 0px 300px 0px' });

      observer.observe(element);
    } else {
      loadEmbeds(scope, getCommentHTML(element));
    }
  }

  return {
    restrict: 'A',
    scope: {
      comment: '=gcEmbed',
      onEmbedDetected: '&',
      embedBatchId: '='
    },
    link: function(scope, elements, attrs) {
      // On load
      $timeout(function() {
        lazyloadEmbeds(scope, elements[0]);
      }, 100);

      // On child-comment change
      scope.$watch('embedBatchId', function(newVal, oldVal) {
        if (newVal !== oldVal) {
          loadEmbeds(scope, getCommentHTML(elements[0]));
        }
      });
    }
  };
}]);
